import { render, staticRenderFns } from "./AdminMenu.vue?vue&type=template&id=11a2cfa3&scoped=true"
import script from "./AdminMenu.vue?vue&type=script&lang=js"
export * from "./AdminMenu.vue?vue&type=script&lang=js"
import style0 from "@/styles/_left_menu.scss?vue&type=style&index=0&id=11a2cfa3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a2cfa3",
  null
  
)

export default component.exports